export function getInitials(firstName?: string, lastName?: string) {
  const firstInitial = firstName?.trim().charAt(0);
  const lastInitial = lastName?.trim().charAt(0);

  return `${firstInitial ?? ""}${lastInitial ?? ""}`.toUpperCase() || "?";
}

export function splitFullName(fullName?: string | null) {
  const names = fullName?.trim().split(/\s+/).filter(Boolean) ?? [];

  return {
    firstName: names.at(0),
    lastName: names.length > 1 ? names.at(-1) : undefined,
  };
}
